import { useQuery } from '@tanstack/react-query';

import { aiPromptTemplatesTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getAIPromptTemplates: aiPromptTemplatesTypes.GetAIPromptTemplates = () => {
  return axios.get('/ai/prompt-templates');
};

type QueryFnType = typeof getAIPromptTemplates;

type UseGetAIPromptTemplatesOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetAIPromptTemplates = ({ config = {} }: UseGetAIPromptTemplatesOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['ai-prompt-templates'],
    queryFn: getAIPromptTemplates,
  });
};
